<template lang="html">
    <div class="proceedings">
        <h6> Ook interessant </h6>
        <ul>
            <router-link to="/vrijmetselarij">
                <li>Lees meer over de Vrijmetselarij</li>
            </router-link>
            <router-link to="/over-onze-loge">
                <li>Lees meer over onze Loge</li>
            </router-link>
            <router-link to="/werktafel">
                <li>Bekijk de Werktafel</li>
            </router-link>
            <router-link to="/artikelen">
                <li>Lees over verschillende onderwerpen</li>
            </router-link>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Proceedings'
}
</script>

<style lang="css" scoped>
</style>
